import IBModuleApi from "../../api/iuviBankingAPI";
import { urlContexts } from "../../constants";

export const getMenu = async (type: "INTERNAL" | "EXTERNAL",
  infObject: {
    tenantid: string,
    roleid?: string,
    appid?: string,
    environmentid?: string,
  }
) => {
  const params = 'menutype=' + type
    + '&tenantid=' + infObject.tenantid
    + (infObject?.roleid ? ('&roleid=' + infObject?.roleid) : '')
    + (infObject?.appid ? ('&appid=' + infObject?.appid) : '')
    + (infObject?.environmentid ? ('&environmentid=' + infObject?.environmentid) : '');

  let dataMenu;
  if (!sessionStorage.getItem('CONSOLE::MENU')) {
    const { data } = await IBModuleApi.get(
      `${process.env.REACT_APP_BACKEND_HOST}/${urlContexts.console}/rest/1.0/cs/menu?${params}`
    );
    dataMenu = data;
    sessionStorage.setItem('CONSOLE::MENU', JSON.stringify(dataMenu));
  } else {
    dataMenu = JSON.parse(sessionStorage.getItem('CONSOLE::MENU')!);
  };

  return dataMenu;
  // return type === "INTERNAL" ? {
  //   data: [
  //   {
  //     "label": "Home",
  //     "icon": "iu iu-icon-home",
  //     "target": "/",
  //     "targettype": "INTERNAL"
  //   },
  //   {
  //     "label": "SetupLabel",
  //     "icon": "iu iu-icon-settings",
  //     "items": [
  //       {
  //         "label": "EndpointLabel",
  //         "target": "/configurations/serverEndpoint",
  //         "targettype": "INTERNAL"
  //       },
  //       {
  //         "label": "FormatAndLanguagesLabel",
  //         "target": "/configurations/initialbankInfo",
  //         "targettype": "INTERNAL"
  //       },
  //       {
  //         "label": "TextsAndMessagesLabel",
  //         "items": [
  //           {
  //             "label": "TextsAndMessagesFrontLabel",
  //             "target": "/translations",
  //             "targettype": "INTERNAL"
  //           }
  //         ]
  //       },
  //       {
  //         "label": "WidgetFunctionalityLabel",
  //         "target": "/widgets",
  //         "targettype": "INTERNAL"
  //       }
  //     ]
  //   },
  //   {
  //     "label": "AutenticationAndSecurityLabel",
  //     "icon": "iu iu-icon-register",
  //     "items": [
  //       {
  //         "label": "GeneralAuthenticationSettingLabel",
  //         "target": "/configurations/security",
  //         "targettype": "INTERNAL"
  //       }
  //     ]
  //   },
  //   {
  //     "label": "ProductTypesLabel",
  //     "icon": "iu iu-icon-wallet",
  //     "items": [
  //       {
  //         "label": "SettingProductTypesLabel",
  //         "target": "/products",
  //         "targettype": "INTERNAL"
  //       },
  //       {
  //         "label": "OpeningProductsLabel",
  //         "target": "/products",
  //         "targettype": "INTERNAL"
  //       }
  //     ]
  //   },
  //   {
  //     "label": "GoogleLabel",
  //     "icon": "iu iu-icon-google",
  //     "target": "http://www.google.com",
  //     "targettype": "EXTERNAL"
  //   }
  // ]}
  // : {
  //   data: [{
  //   "label": "Home",
  //   "icon": "iu iu-icon-home",
  //   "target": "/users",
  //   "targettype": "INTERNAL"
  // },
  // {
  //   "label": "applicationMenuLabel",
  //   "items": [
  //     {
  //       "label": "adminClientsMenuLabel",
  //       "target": "/tenants",
  //       "targettype": "INTERNAL"
  //     },
  //     {
  //       "label": "adminAgentsMenuLabel",
  //       "target": "/agents",
  //       "targettype": "INTERNAL"
  //     },
  //     {
  //       "label": "adminApplicationMenuLabel",
  //       "target": "/applications",
  //       "targettype": "INTERNAL"
  //     }
  //   ]
  // },
  // {
  //   "label": "accessMenuLabel",
  //   "items": [
  //     {
  //       "label": "rolesAdministrationMenuLabel",
  //       "target": "/adminroles",
  //       "targettype": "INTERNAL"
  //     },
  //     {
  //       "label": "auditMenuLabel",
  //       "target": "/",
  //       "targettype": "INTERNAL"
  //     }
  //   ]
  // },
  // {
  //   "label": "adminConsoleMenuLabel",
  //   "items": [
  //     {
  //       "label": "consoleTranslationsMenuLabel",
  //       "target": "/consoletranslations",
  //       "targettype": "INTERNAL"
  //     },
  //     {
  //       "label": "catalogueAdministrationMenuLabel",
  //       "target": "",
  //       "targettype": "INTERNAL"
  //     },
  //     {
  //       "label": "permissionAdministrationMenuLabel",
  //       "target": "/permissions",
  //       "targettype": "INTERNAL"
  //     },
  //     {
  //       "label": "functionalityAdministrationMenuLabel",
  //       "target": "/functionalities",
  //       "targettype": "INTERNAL"
  //     }
  //   ]
  // }]};
};